import React, { useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true); // Optional: show loading state

        try {
            const response = await axios.post('https://horizontclinic.com/horizont-be/login.php', {
                email,
                password
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Login Response:', response);

            if (response.data.status === 'success') {
                // Store token in localStorage
                localStorage.setItem('token', response.data.token);

                // Redirect to the dashboard
                window.location.href = "/dashboard";
            } else {
                // Show error message if login fails
                setMessage(response.data.message || 'Login failed.');
            }
        } catch (error) {
            // Catch and log any errors
            setMessage('An error occurred. Please try again.');
            console.error('Error logging in:', error);
        } finally {
            setLoading(false); // Hide loading state
        }
    };


    return (
        <div className="container-fluid d-flex justify-content-center align-items-center vh-100 loginBg">
            <div className="row">
                <div className="col-12 card shadow-lg border-0 rounded">
                    <form onSubmit={handleSubmit} className="">
                        <div className="d-flex justify-content-center w-100 my-4">
                            <img
                                src={"/logo.png"}
                                alt="Logo"
                                className="w-25"
                            />
                        </div>

                        <div className="mb-4 text-center px-5">
                            <TextField
                                className={"w-100"}
                                type="email"
                                id="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                label="Email"
                                variant="outlined" />
                        </div>
                        <div className="mb-4 text-center px-5">
                            <TextField
                                className={"w-100"}
                                type={showPassword ? 'text' : 'password'}
                                id="password"
                                name="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                label="Password"
                                variant="outlined"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={showPassword ? 'Hide password' : 'Show password'}
                                                onClick={() => setShowPassword(p => !p)}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </div>

                        <Button
                            className={"mb-4 justify-content-center d-flex mx-auto"}
                            color={"primary"}
                            type="submit"
                            size={"large"}
                            disabled={loading}
                            variant="contained">
                            {loading ? 'Logging in...' : 'Login'}
                        </Button>

                        {message && <p className="mt-4 text-center">{message}</p>}
                    </form>
                </div>
            </div>
        </div>

    );
};

export default Login;
